/** @file Reads one local channel of a posed bone (setup + animation + preview, before constraints). */
import { POSE_LAYOUT } from '@pose2d/core/contracts/pose';
import type { Pose } from '@pose2d/core/types';
import { CHANNEL_OFFSET, type LocalChannel } from './channelOffset';

/** `pose.local` value of `channel` for data bone `bone`. */
export function localValue(pose: Pose, bone: number, channel: LocalChannel): number {
  return pose.local[bone * POSE_LAYOUT.LOCAL_STRIDE + CHANNEL_OFFSET[channel]] ?? 0;
}
